// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SessionEngineEventDateResponse

import { DateTimefromYmd } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type SessionEngineEventDateApiResponse = {
	date: string;
	startMinutes: number;
	endMinutes: number;
};

export type SessionEngineEventDate = {
	date: DateTime;
	startMinutes: number;
	endMinutes: number;
};

export function hydrateSessionEngineEventDate(data: SessionEngineEventDateApiResponse): SessionEngineEventDate {
	return {
		...data,
		date: DateTimefromYmd(data.date)!,
	};
}